import { type LegalEntitySummary } from '../LegalEntitySummary'

export interface PrimaryCategoryConstructor {
  id: number
  name: string
  legalEntity?: Nullable<LegalEntitySummary>
}

export class PrimaryCategory {
  id: number
  name: string
  legalEntity?: Nullable<LegalEntitySummary>

  constructor(data: PrimaryCategoryConstructor) {
    this.id = data.id
    this.name = data.name
    this.legalEntity = data.legalEntity ?? null
  }
}
